/* The component picker owns its catalogue and product compatibility. Share only
   the drawer presentation with storefront search and collection filters. */
(() => {
  'use strict';
  const keys = {
    brand:'filter.p.vendor',
    stock:'filter.v.availability',
    min:'filter.v.price.gte',
    max:'filter.v.price.lte'
  };
  const fold = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const tr = (fr,en) => document.documentElement.lang.toLowerCase().startsWith('en') ? en : fr;
  const controls = root => ({
    brands:[...root.querySelectorAll('[data-cb-vendor]')],
    available:root.querySelector('[data-cb-available]'),
    min:root.querySelector('[data-cb-min]'),
    max:root.querySelector('[data-cb-max]')
  });
  function prepare(root) {
    if (!window.CabaneFiltersDrawer || !window.CabaneFiltersAdapter || !window.HTMLDialogElement?.prototype.showModal) return;
    const legacy=root.querySelector('[data-cb-filter-panel]');
    if (legacy && !legacy.hidden) {
      legacy.hidden=true;
      const trigger=root.querySelector('[data-cb-filter-open]');
      trigger.setAttribute('aria-expanded','false');
      trigger.setAttribute('aria-haspopup','dialog');
    }
  }
  function context(trigger) {
    const root=trigger.closest('[data-atelier-builder]'), picker=trigger.closest('[data-cb-picker-dialog][open]');
    const products=root && window.CabanePickerFilters?.catalog(root);
    if (!picker || !Array.isArray(products)) return null;
    const ctl=controls(root), params=new URLSearchParams();
    ctl.brands.filter(input=>input.checked).forEach(input=>params.append(keys.brand,input.dataset.cbVendor));
    if (ctl.available.checked) params.set(keys.stock,'1');
    if (ctl.min.value) params.set(keys.min,ctl.min.value);
    if (ctl.max.value) params.set(keys.max,ctl.max.value);
    const term=fold(root.querySelector('[data-cb-search]').value);
    const brand=root.querySelector('[data-cb-brand]').value;
    const pool=products.filter(p=>(!brand || p.vendor===brand) && (!term || p._search.includes(term)));
    const ctx={
      kind:'builder',root,trigger,products,pool,params,discipline:'builder',
      title:picker.querySelector('#cb-picker-title')?.textContent.trim() || tr('Ton setup','Your setup'),
      currency:window.Shopify?.currency?.active || 'EUR'
    };
    ctx.initial=query(ctx,params);
    return ctx;
  }
  function query(ctx,params,signal) {
    signal?.throwIfAborted();
    const brands=params.getAll(keys.brand), min=params.get(keys.min), max=params.get(keys.max);
    const available=params.has(keys.stock,'1');
    const matching=window.CabanePickerFilters.matching;
    const eligible=matching(ctx.pool,[],min,max,available);
    const vendors=[...new Set(ctx.products.map(p=>p.vendor).filter(Boolean))].sort((a,b)=>a.localeCompare(b));
    const frequencies=new Map();
    for (const p of eligible) frequencies.set(p.vendor,(frequencies.get(p.vendor)||0)+1);
    const values=vendors.map(vendor=>({label:vendor,value:vendor,count:frequencies.get(vendor)||0}));
    const inStock=matching(ctx.pool,brands,min,max,true).length;
    const maxPrice=ctx.products.reduce((max,p)=>p.variants.reduce((n,v)=>Math.max(n,v.price),max),0);
    return {
      count:matching(ctx.pool,brands,min,max,available).length,
      facets:[
        {key:keys.brand,type:'list',label:tr('Marque','Brand'),values},
        {key:keys.stock,type:'list',label:tr('Disponibilité','Availability'),
          values:[{value:'1',label:tr('En stock','In stock'),count:inStock}]},
        {key:'filter.v.price',type:'price',label:tr('Prix','Price'),minKey:keys.min,maxKey:keys.max,
          limit:Math.ceil(maxPrice/100),values:[]}
      ]
    };
  }
  function apply(ctx,params,_stage,signal) {
    signal?.throwIfAborted();
    const {root}=ctx;
    if (window.CabanePickerFilters.catalog(root)!==ctx.products) throw new Error('Component selection changed');
    const ctl=controls(root), brands=new Set(params.getAll(keys.brand));
    ctl.brands.forEach(input=>{input.checked=brands.has(input.dataset.cbVendor);});
    ctl.available.checked=params.has(keys.stock,'1');
    ctl.min.value=params.get(keys.min) || '';
    ctl.max.value=params.get(keys.max) || '';
    window.CabanePickerFilters.commit(root);
  }
  window.CabaneBuilderFilterAdapter={prepare,context,query,apply,focus:ctx=>ctx?.trigger?.focus({preventScroll:true})};
})();
